import './style.css';

const ContentWrap: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <div className='content-wrap'>{children}</div>;
};

export default ContentWrap;
